<template>
  <div class="ep">
    <iframe
      :src="iframeSrc"
      style="border: none; width: 100%; height: 100vh"
    />
  </div>
</template>
<script>
import { FORMFLOW_CAS, FLOW_DESIGN_URL } from '@/utils/service.js'
export default {
  data () {
    return {
      iframeSrc: ''
    }
  },
  created () {
    const redirectUri = `${FLOW_DESIGN_URL}/static/app/monitor.html?fid=${this.$route.query.yyid}&time=${Date.now()}`
    this.iframeSrc = FORMFLOW_CAS + '?redirect_uri=' + encodeURIComponent(redirectUri)
  },
  methods: {

  }
}
</script>
